import React from "react";
import { motion } from "framer-motion";
import { FaCode, FaPython, FaGlobe, FaDatabase } from "react-icons/fa";
import { HiArrowRight } from "react-icons/hi2";
import "./Services.css";

const services = [
  {
    id:       "software",
    icon:     <FaCode />,
    color:    "var(--accent)",
    glow:     "var(--accent-glow)",
    label:    "Desarrollo de Software",
    tagline:  "Soluciones escalables & producción-ready",
    bullets: [
      "Arquitectura limpia y modular (Clean Architecture)",
      "APIs RESTful y GraphQL con Node.js / Express",
      "Optimización de rendimiento y seguridad",
      "Integración con bases de datos SQL y NoSQL",
    ],
    cta:  "Ver proyectos",
    href: "/projects",
  },
  {
    id:       "python",
    icon:     <FaPython />,
    color:    "var(--violet)",
    glow:     "var(--violet-glow)",
    label:    "Automatización con Python",
    tagline:  "Scripts que trabajan mientras tú descansas",
    bullets: [
      "Bots de Telegram, Discord y WhatsApp",
      "Automatización de tareas repetitivas (Excel, PDF, APIs)",
      "Scheduling y cron jobs inteligentes",
      "Pipelines de datos y reportes automáticos",
    ],
    cta:  "Ver automatizaciones",
    href: "/projects",
  },
  {
    id:       "web",
    icon:     <FaGlobe />,
    color:    "var(--cyan)",
    glow:     "var(--cyan-glow)",
    label:    "Desarrollo Web",
    tagline:  "Aplicaciones interactivas y dinámicas",
    bullets: [
      "React, Next.js — SSR, SSG, ISR",
      "UI/UX premium con animaciones fluidas",
      "Optimización SEO y Core Web Vitals",
      "PWA y apps responsivas para cualquier dispositivo",
    ],
    cta:  "Ver demos",
    href: "/projects",
  },
  {
    id:       "scraping",
    icon:     <FaDatabase />,
    color:    "var(--emerald)",
    glow:     "var(--emerald-glow)",
    label:    "Web Scraping",
    tagline:  "Extracción de datos compleja sin límites",
    bullets: [
      "Scrapers robustos con Playwright / Selenium",
      "Anti-bot bypass (Cloudflare, CAPTCHAs)",
      "Pipelines de limpieza y normalización de datos",
      "Exportación a JSON, CSV, SQL o APIs propias",
    ],
    cta:  "Solicitar demo",
    href: "/#Contact",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.12,
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    },
  }),
};

const Services = React.memo(function Services() {
  return (
    <section id="servicios" className="services">
      <div className="container">

        {/* Header */}
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="section-label">¿Qué ofrezco?</span>
          <h2 className="section-title">Servicios Profesionales</h2>
          <p className="section-subtitle">
            Soluciones digitales end-to-end para negocios que buscan
            crecer con tecnología de calidad.
          </p>
        </motion.div>

        {/* Cards grid */}
        <div className="services-grid">
          {services.map((svc, i) => (
            <motion.div
              key={svc.id}
              className="service-card glass-card"
              custom={i}
              variants={cardVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
              whileHover={{ y: -6, transition: { duration: 0.25 } }}
              style={{ "--svc-color": svc.color, "--svc-glow": svc.glow }}
            >
              {/* Icon */}
              <div className="service-icon-wrap">
                <span className="service-icon">{svc.icon}</span>
              </div>

              {/* Text */}
              <div className="service-body">
                <h3 className="service-title">{svc.label}</h3>
                <p className="service-tagline">{svc.tagline}</p>

                <ul className="service-bullets">
                  {svc.bullets.map((b, idx) => (
                    <li key={idx}>
                      <span className="service-bullet-dot" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA */}
              <a href={svc.href} className="service-cta">
                {svc.cta} <HiArrowRight className="service-cta-icon" />
              </a>

              {/* Glow border top */}
              <div className="service-glow-line" />
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          className="services-bottom"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          
        </motion.div>
      </div>
    </section>
  );
});

export default Services;
